import React, { useState } from "react";
import {
    AiOutlineArrowLeft,
    AiOutlineArrowRight,
    AiOutlineShoppingCart,
} from "react-icons/ai";
import Slider from "react-slick";
import { Link } from 'react-router-dom'
import viewAllImge from '../assets/viewall.png'


const NextArrow = ({ onClick }) => {
    return (
        <div
            onClick={onClick}
            className="absolute cursor-pointer lg:-right-10 shadow-md bg-white p-4 rounded-full md:right-4 top-[47%]"
        >
            <AiOutlineArrowRight />
        </div>
    );
};
const PrevArrow = ({ onClick }) => {
    return (
        <div
            onClick={onClick}
            className="absolute cursor-pointer lg:-left-10 shadow-md bg-white p-4 rounded-full md:-left-10 left-3 z-10 top-[47%] "
        >
            <AiOutlineArrowLeft />
        </div>
    );
};

const ProductCard = ({ product }) => {
    return (<a
        href=""
        className="w-96 relative shadow-none"
        key={product?.id}
    >
        <div className="absolute top-6 right-6 cursor-pointer z-50 p-2 hover:scale-110 transition-all bg-white rounded-full">
            <AiOutlineShoppingCart />
        </div>
        <div className=" ">
            <img
                src={product?.image}
                alt="profile-picture"
                className="h-full w-full object-contain rounded-md "
            />
        </div>
        <div className="text-start pl-1">
            <div variant="" color="blue-gray" className="mb-0 font-light">
                {product?.name}
            </div>
            <div color="blue" className="font-medium text-xs">
                {product?.price}
            </div>
        </div>
    </a>
    )
}
const ViewAllCard = () => {
    return (
        <a
            href=""
            className="w-96 relative shadow-none"
            key={'view_all'}
        >
            <div className=" ">
                <img
                    src={viewAllImge}
                    alt="profile-picture"
                    className="h-full w-full object-contain rounded-md "
                />
            </div>
            <div className="text-start pl-1">
                {/* <div variant="" color="blue-gray" className="mb-0 font-light">
                    {product?.name}
                </div>
                <div color="blue" className="font-medium text-xs">
                    {product?.price}
                </div> */}
            </div>
        </a>
    )
}
const ProductSlider = ({ products = [] }) => {
    const [defaultImage, setDefaultImage] = useState({});
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                },
            },
        ],
    };

    const handleErrorImage = (data) => {
        setDefaultImage((prev) => ({
            ...prev,
            [data.target.alt]: data.target.alt,
            linkDefault: "",
        }));
    };

    return (
        <div className="p-1 sm:p-6">
            <Slider {...settings}>
                {products.map(prod => <ProductCard product={prod} />)}
                <ViewAllCard />
            </Slider>
        </div>
    );
};

const NewArrival = ({ title = "promotion", subTitle = "Discount Items", products = [] }) => {
    return (
        <div className="p-1 sm:p-4 space-y-4">
            <div className="text-center justify-between mt-5">
                <h2 className="uppercase sm:text-[13px] text-[10px] ">{title}</h2>
                <h1 className="uppercase sm:text-[20px] text-[16px]">{subTitle}</h1>
                {/* <div className="h-3 sm:h-5 bold">{title}</div> */}
                {/* <Link to={"#"} className="ml-auto text-center">View All</Link> */}
            </div>
            <ProductSlider products={products} />
        </div>
    )
}

export default NewArrival;